<script setup lang="ts">
import type { CreateCompanyForEmployerInvoiceDto } from '@swipe4work/models-orval'
import nProgress from 'nprogress'
import BillingForm from '@/pages/onboarding/components/BillingForm.vue'

definePage({
  path: '/upgrade/facturatie',
  meta: {
    permissionResource: 'Lead',
    shell: {
      showLeadPromotion: false,
    },
  },
})

const upgradeStore = useUpgradeStore()

await upgradeStore.fill()

const { selectedPaymentMethod, invoiceModel } = storeToRefs(upgradeStore)

function prevPage() {
  upgradeStore.goToPage(1)
}

if (!selectedPaymentMethod.value) {
  prevPage()
}

const submitting = ref(false)

async function submit(model: CreateCompanyForEmployerInvoiceDto, hasAcceptedTermsAndConditions: boolean) {
  nProgress.start()
  submitting.value = true
  invoiceModel.value = model
  await upgradeStore.convertLeadCompanyToRegular(hasAcceptedTermsAndConditions)
  nProgress.done()
  submitting.value = false
}
</script>

<template>
  <BillingForm :submitting="submitting" @next-page="submit" @prev-page="prevPage" />
</template>
